import { useContext, useEffect, useState } from 'react';
import { DisaggregatedMetric, GeoDetails } from '../services/types';
import useDeepCompareEffect from './useDeepCompareEffect';
import MetricCategoriesContext from '../context/MetricCategoriesContext';
import { useOrgId } from '../context/OrgIdContext';

const useFetchData = (currentTab: string) => {
    const orgId = useOrgId()
    const { metricCategories } = useContext(MetricCategoriesContext);

    const [indicators, setIndicators] = useState<DisaggregatedMetric[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    const [dashboardView, setDashboardView] = useState('');
    const geoDetails: GeoDetails[] = [];

    const geoEncoding = 'delta';
    const indicatorsUrl = `${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getallindicatorsv2`;

    useEffect(() => {
        // Ensure the dashboardView is synced with currentTab
        setDashboardView(currentTab?.toLowerCase());
    }, [currentTab]);

    useDeepCompareEffect(() => {
        const fetchData = async () => {
            console.log('details:', orgId, dashboardView);

            if (!dashboardView) {
                console.log('Current tab is not selected. Skipping fetch...');
                setLoading(false);
                return;
            }

            // Check if dashboardView (in lowercase) is in metricCategories (also converted to lowercase)
            const lowercaseMetricCategories = metricCategories.map(category => category.toLowerCase());
            if (!lowercaseMetricCategories.includes(dashboardView.toLowerCase())) {
                console.log('dashboardView is not in metricCategories. Skipping fetch...');
                return;
            }
            
            try {
                if (orgId !== null) {
                    setLoading(true);
                    // Fetch indicators data for current view
                    const indicatorsResponse = await fetch(indicatorsUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ orgId, dashboardView, geoDetails, geoEncoding, allowDefault: true }),
                    });

                    if (!indicatorsResponse.ok) {
                        throw new Error('Network response was not ok');
                    }

                    const indicatorsResult = await indicatorsResponse.json();
                    console.log('indicators result:', indicatorsResult);
                    setIndicators(indicatorsResult);
                }
            } catch (error: any) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [orgId, dashboardView, metricCategories]);

    return { indicators, loading, error, dashboardView };
};

export default useFetchData;